"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeOnce = exports.subscribe = exports.setState = exports.state = void 0;
var stateFactory_1 = require("./stateFactory");
var _a = stateFactory_1.useState(), state = _a.state, setState = _a.setState, subscribe = _a.subscribe, subscribeOnce = _a.subscribeOnce;
exports.state = state;
exports.setState = setState;
exports.subscribe = subscribe;
exports.subscribeOnce = subscribeOnce;
